import { MoreVertical, Trash2 } from 'lucide-react'
import Image from 'next/image'
import { useEffect, useRef, useState } from 'react'

interface ChatHeaderProps {
  wsConnected: boolean
  onClearChat: () => void
}

const ChatHeader = ({ wsConnected, onClearChat }: ChatHeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div className='flex items-center gap-3 bg-[linear-gradient(90deg,#E1B2D2_0%,#BAE4F2_100%)] p-5'>
      {/* <div
        className={`
          flex h-9 w-9 items-center justify-center rounded-full bg-white
          shadow-xl
        `}
      >
        <BotMessageSquare className='text-[#F59405]' />
      </div> */}
      <Image src='/images/botIcon.png' alt='Chat Bot Description' width={50} height={50} objectFit='contain' className='-mt-1' />

      <div className='ml-auto flex flex-row items-center gap-2'>
        <div
          className={`
            h-2 w-2 rounded-full

            ${wsConnected ? 'bg-transparent' : `bg-transparent`}
          `}
          title={wsConnected ? 'Connected' : 'Disconnected'}
        />
        <div className='relative' ref={menuRef}>
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`
              cursor-pointer
            `}
          >
            <MoreVertical className='text-black' />
          </button>
          {isMenuOpen && (
            <div
              className={`
                absolute right-0 z-50 mt-2 w-48 rounded-md bg-white py-1
                shadow-lg ring-1 ring-black ring-opacity-5
              `}
            >
              <button
                onClick={() => {
                  onClearChat()
                  setIsMenuOpen(false)
                }}
                className={`
                  flex w-full items-center gap-2 px-4 py-2 text-sm text-gray-700

                  hover:bg-gray-100
                `}
              >
                <Trash2 className='h-4 w-4' />
                Clear Chat
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ChatHeader
